// extracted by mini-css-extract-plugin
module.exports = {"achievementsList":"AchievementsList_achievementsList__CSY2u"};